"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var auth_suite_config_1 = require("@cbsi-cbscom/auth-suite-config");
var QaEnvConfigPrototype = /** @class */ (function (_super) {
    tslib_1.__extends(QaEnvConfigPrototype, _super);
    function QaEnvConfigPrototype() {
        return _super.call(this, QaEnvConfigPrototype.regionToAuthSuiteUrl, "https://api.auth-staging.adobe.com", "https://musicjsonpath-a.akamaihd.net") || this;
    }
    QaEnvConfigPrototype.regionToAuthSuiteUrl = new Map([
        [auth_suite_config_1.NetworkRegion.EU, "https://eu.auth.mtvnservices-q.mtvi.com"],
        [auth_suite_config_1.NetworkRegion.GLOBAL, "https://auth.mtvnservices-q.mtvi.com"],
    ]);
    return QaEnvConfigPrototype;
}(auth_suite_config_1.EnvConfigPrototype));
var envConfig = new QaEnvConfigPrototype();
auth_suite_config_1.configBase.setConfig(envConfig.build());
exports.default = envConfig;
